/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Password_Errors_Password_Requires_LowerInputs */

const nl_auth_password_errors_password_requires_lower = /** @type {(inputs: Auth_Password_Errors_Password_Requires_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het wachtwoord moet minimaal één kleine letter bevatten`)
};

/**

* @param {Auth_Password_Errors_Password_Requires_LowerInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const auth_password_errors_password_requires_lower = /** @type {((inputs?: Auth_Password_Errors_Password_Requires_LowerInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Password_Errors_Password_Requires_LowerInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_auth_password_errors_password_requires_lower(inputs)
});
export { auth_password_errors_password_requires_lower as "auth.password_errors.password_requires_lower" }